import { defineComponent as _defineComponent } from 'vue'
import { FeatureFlags } from "@busy-human/vue-component-library";
import { computed, ref, onMounted } from "vue";
const defaultMessage = "This page is showing filler data";
type Props = {
	message?: string
	anchor?: "none" | "bottom" | "bottom-right"
}

export default /*#__PURE__*/_defineComponent({
  __name: 'under-construction',
  props: {
    message: {},
    anchor: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const isBetaUser = ref(false);
const props = __props;

onMounted(async () => {
    isBetaUser.value = await FeatureFlags.isFeatureEnabledWithNamedCondition("BETA_BUILDER_CHECKLIST", "betaTester");
});

const classes = computed(() => {
	const _classes = [];
	let anchor = props.anchor || "bottom-right";
	if(anchor && anchor !== "none") {
		_classes.push(`anchor-${anchor}`);
	}
	return _classes;
});


const __returned__ = { defaultMessage, isBetaUser, props, classes, get FeatureFlags() { return FeatureFlags }, computed, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})